require('./bootstrap');
import flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es.js"; // Importar en español
import "flatpickr/dist/flatpickr.min.css";
